import { Component } from '@angular/core';

import { trackByValue } from '@recruitee/common';

import { ButtonComponent } from '../../common/button/components/button/button.component';
import { HeadingComponent } from '../../common/heading/heading.component';
import { IconComponent } from '../../common/icon/icon.component';
import { DialogBodyComponent } from '../../dialog/dialog-body/dialog-body.component';
import { DialogRef } from '../../dialog/dialog-ref';
import type { DialogComponentI } from '../../dialog/dialog.component';
import type { IconName } from '../../icons-container/icons.type';

type IllustrationDialogResult = string | number | boolean;

interface IllustrationDialogButton {
  text: string;
  variant: 'primary' | 'default' | 'outline' | string;
  result?: IllustrationDialogResult;
  icon?: IconName;
  handler?: (dialogRef: DialogRef<IllustrationDialogComponent>) => void;
}

export interface IllustrationDialogData {
  imageSrc: string;
  imageHeight?: string;
  message: string;
  description?: string;
  descriptionVariant?: string;
  buttons: IllustrationDialogButton[];
}

@Component({
  selector: 'rt-congrats-dialog',
  templateUrl: './illustration-dialog.component.html',
  styleUrls: ['./illustration-dialog.component.less'],
  imports: [ButtonComponent, DialogBodyComponent, HeadingComponent, IconComponent],
})
export class IllustrationDialogComponent
  implements DialogComponentI<IllustrationDialogData, IllustrationDialogResult>
{
  public imageSrc: string;
  public imageHeight: string;
  public message: string;
  public description?: string;
  public descriptionVariant: string;
  public buttons: IllustrationDialogButton[];
  public trackByValue = trackByValue;

  constructor(private dialogRef: DialogRef<IllustrationDialogComponent>) {}

  public setDialogData(data: IllustrationDialogData): void {
    this.imageSrc = data.imageSrc;
    this.message = data.message;
    this.buttons = data.buttons;
    this.description = data.description;
    this.descriptionVariant = data.descriptionVariant ?? 'subheading';
    this.imageHeight = data.imageHeight ?? '220px';
  }

  public close(button: IllustrationDialogButton): void {
    button.handler ? button.handler(this.dialogRef) : this.dialogRef.close(button.result);
  }
}
